/**
 * Step ID enums extraits de stepsConstants.ts pour eviter le cycle
 * d'imports declenche par 'import Containers from ../containers' dans
 * stepsConstants.ts. Ces enums sont des valeurs statiques pures qui
 * n'ont besoin d'aucun import.
 *
 * Les fichiers consommateurs qui n'ont besoin QUE des enums (sans
 * BFF_STEPS_IDS, ALL_STEPS, etc.) doivent importer depuis ici.
 *
 * stepsConstants.ts re-exporte ces enums pour preserver la
 * compatibilite avec les autres consommateurs.
 */

export enum APPLICANT_STEP_ID {
  PERSONAL_INFOS = 'PERSONAL_INFOS_STEP',
  EMPLOYMENT = 'EMPLOYMENT_STEP',
  EMPLOYMENT_V2 = 'EMPLOYMENT_V2_STEP',
  FINANCE = 'FINANCE_STEP',
  TAXES = 'TAX_STEP',
  SPECIFIC_BANKING_INFO = 'BANKING_INFOS_STEP',
}

export const APPLICANT_STEPS_IDS_LIST: APPLICANT_STEP_ID[] = [
  APPLICANT_STEP_ID.PERSONAL_INFOS,
  APPLICANT_STEP_ID.EMPLOYMENT,
  APPLICANT_STEP_ID.EMPLOYMENT_V2,
  APPLICANT_STEP_ID.FINANCE,
  APPLICANT_STEP_ID.TAXES,
  APPLICANT_STEP_ID.SPECIFIC_BANKING_INFO,
];

export enum SPOUSE_STEP_ID {
  PERSONAL_INFOS = 'PERSONAL_INFOS_STEP_JOINT',
  EMPLOYMENT = 'EMPLOYMENT_STEP_JOINT',
  EMPLOYMENT_V2 = 'EMPLOYMENT_V2_STEP_JOINT',
  FINANCE = 'FINANCE_STEP_JOINT',
  TAXES = 'TAX_STEP_JOINT',
  SPECIFIC_BANKING_INFO = 'BANKING_INFOS_STEP_JOINT',
}

export const SPOUSE_STEPS_IDS_LIST: SPOUSE_STEP_ID[] = [
  SPOUSE_STEP_ID.PERSONAL_INFOS,
  SPOUSE_STEP_ID.EMPLOYMENT,
  SPOUSE_STEP_ID.EMPLOYMENT_V2,
  SPOUSE_STEP_ID.FINANCE,
  SPOUSE_STEP_ID.TAXES,
  SPOUSE_STEP_ID.SPECIFIC_BANKING_INFO,
];
